module.exports = __webpack_public_path__ + "img/nekhl.e6d7cc2e.jpg";